<template>
  <div class="layout-node" :class="nodeClasses" :style="style" @click.stop="onClick">
    <span class="caption">{{caption}}</span>
    <span class="columns" v-if="columns"><i class="el-icon-s-grid"></i>{{columns}}</span>
    <div class="child-nodes">
      <app-layout-node
        v-for="child in node.Children"
        :key="child.Name"
        :node="child"
        :active-node="activeNode"
        :active-tab="activeTab"
        :active-tab2nd="activeTab2nd"
        @app-event="onAppEvent">
      </app-layout-node>
    </div>
  </div>
</template>

<style scoped>
.layout-node {
  display: block;
  position: absolute;
  z-index:auto;
  overflow: visible;
  box-sizing:border-box;

  font-size: 10px;
  margin:0px;
  border: solid 1px;
  border-color: #CCC;
  border-radius: 4px;
}
.layout-node.is_active {
  border-color: #C66 !important;
  border-width: 1.5px;
  z-index:100;
}
.is_not_active_tab.is_not_active_tab {
  display: none;
}
.layout-node .child-nodes{
  display: block;
  position: absolute;
}
</style>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';
import * as sas from '@/core/decorators';

@Component()
export default class AppLayoutNode extends AppComponent {
  @Prop({ require: true })
  node;

  @Prop({ require: true })
  activeNode;

  @Prop({ require: true })
  activeTab;

  @Prop({ require: true })
  activeTab2nd;

  @Prop({ require: false })
  isRoot;

  get type () {
    if ('Type' in this.node) {
      return this.node.Type;
    }
    return null;
  }

  get caption () {
    if ('Caption' in this.node) {
      return this.node.Caption;
    }
    return null;
  }

  get columns () {
    if ('Columns' in this.node) {
      const columns = [];
      for (let index in this.node.Columns) {
        columns.push(this.node.Columns[index].Title.Caption);
      }
      return columns.join('|');
    }
    return null;
  }

  get nodeClasses () {
    const classes = [];
    // アクティブ判定
    if (this.activeNode !== null && this.activeNode.Name === this.node.Name) {
      classes.push('is_active');
    }
    // タブ判定
    if (this.node.Type === 'TTabSheet') {
      if ((this.node !== this.activeTab) && (this.node !== this.activeTab2nd)) {
        classes.push('is_not_active_tab');
      }
    }
    return classes;
  }

  /**
   * 配置用スタイルデータ生成
   */
  get style () {
    const rectangle = {
      left: this.left,
      top: this.top,
      width: this.width,
      height: this.height
    }
    return {
      left: rectangle.left + 'px',
      top: rectangle.top + 'px',
      width: rectangle.width + 'px',
      height: rectangle.height + 'px'
    };
  }
  get top () {
    if (this.isRoot) {
      return 0;
    }

    if ('Top' in this.node) {
      return this.node.Top * 1;
    } else {
      // console.log(this.node.Name, 'No Top');
      return 0;
    }
  }
  get left () {
    if (this.isRoot) {
      return 0;
    }

    if ('Left' in this.node) {
      return this.node.Left * 1;
    } else {
      // console.log(this.node.Name, 'No Left');
      return 0;
    }
  }
  get width () {
    if ('Width' in this.node) {
      return this.node.Width * 1;
    } else {
      if (this.isForm || this.isTabSheet) {
        return this.node.Children[0].Width;
      }
      // console.log(this.node.Name, 'No Width');
      return 0;
    }
  }
  get height () {
    if ('Height' in this.node) {
      return this.node.Height * 1;
    } else {
      if (this.isForm || this.isTabSheet) {
        return this.node.Children[0].Height;
      }
      // console.log(this.node.Name, 'No Height');
      return 0;
    }
  }
  get isForm () {
    if (this.type === null) { return false; }
    return (this.type.match(/Form$/));
  }
  get isTabSheet () {
    if (this.type === null) { return false; }
    return (this.type.match(/TabSheet$/));
  }

  @sas.BindApi
  data () {
    return {
    }
  }

  /**
   * 初期化
   */
  initialize () {
  }

  /**
   * クリックイベント
   */
  onClick () {
    this.$emit('app-event', 'change:activeNode', this.node);
  }

  /**
   * アプリケーションイベント
   */
  onAppEvent (...args) {
    this.$emit('app-event', ...args);
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppLayoutNode.vue